import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable()
export class LoadManagerService {
    private loadRequests: number;
    private loadStatusUpdatedSource: Subject<boolean>;
    public readonly loadStatusUpdated: Observable<boolean>;

    constructor() {
        this.loadRequests = 0;
        this.loadStatusUpdatedSource = new Subject<boolean>();
        this.loadStatusUpdated = this.loadStatusUpdatedSource.asObservable();
    }

    public get isLoading(): boolean {
        return this.loadRequests > 0;
    }

    public incLoadRequest(): boolean {
        this.loadRequests++;
        this.loadStatusUpdatedSource.next(this.isLoading);

        return this.isLoading;
    }

    public decLoadRequest(): boolean {
        if (this.loadRequests > 0) {
            this.loadRequests--;
            this.loadStatusUpdatedSource.next(this.isLoading);
        }

        return this.isLoading;
    }
}